"use client";

import { useQuery } from "@tanstack/react-query";
import { fetchStages, trendKeys } from "@/lib/queries";

export function FallbackBanner() {
  const { data } = useQuery({
    queryKey: trendKeys.stages(),
    queryFn: () => fetchStages(),
  });

  if (!data?.is_fallback || !data.date) return null;

  const d = new Date(data.date);
  const label = `${d.getMonth() + 1}월 ${d.getDate()}일`;

  return (
    <div className="mx-4 mt-3 py-2 px-3 rounded-lg bg-primary/10 text-primary text-xs text-center">
      📅 오늘자 수집 전 — {label} 기준 표시 중
    </div>
  );
}
